import IcArrowUp from '../assets/images/ic_arrow_up.svg'
import IcArrowDown from '../assets/images/ic_arrow_down.svg'
import styled from 'styled-components';

const NumberInputContainer = styled.div`
    display: flex;
    flex-direction: row;
`

// 💡 NumberText 대신 타이핑이 가능한 input 요소 사용
const NumberInputField = styled.input`
    font-family: 'Pretendard Variable';
    font-weight: 400;
    font-size: 1rem;
    color: #000000;
    width: 2.5rem;
    height: 1.75rem;
    border-top-left-radius: 0.125rem;
    border-bottom-left-radius: 0.125rem;
    border-bottom: 0.03125rem solid #B9B9B9;
    border-left: 0.015625rem solid #B9B9B9;
    border-top: 0.03125rem solid #B9B9B9;
    border-right: 0.03125rem solid #B9B9B9;

    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    text-align: center; /* 입력된 숫자를 중앙에 정렬 */
    padding: 0; /* 기본 padding 제거 */
    outline: none; /* 포커스 시 기본 테두리 제거 */

    /* 브라우저 기본 숫자 스피너 제거 */
    -moz-appearance: textfield; /* Firefox */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`;

const ArrowContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const UpArrowContainer = styled.div`
    width: 1rem;
    height: 50%;
    border-bottom: 0.015625rem solid #B9B9B9;
    border-top: 0.03125rem solid #B9B9B9;
    border-right: 0.03125rem solid #B9B9B9;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-right-radius: 0.125rem;
    cursor: pointer; /* 클릭 가능함을 명시 */

    &:active {
        background-color: #f0f0f0; /* 클릭 시 시각적 피드백 */
    }
`;

const DownArrowContainer = styled.div`
    width: 1rem;
    height: 50%;
    border-bottom: 0.03125rem solid #B9B9B9;
    border-right: 0.03125rem solid #B9B9B9; /* 통일성을 위해 border-right 값을 위와 맞춤 */
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom-right-radius: 0.125rem;
    cursor: pointer; /* 클릭 가능함을 명시 */

    &:active {
        background-color: #f0f0f0; /* 클릭 시 시각적 피드백 */
    }
`;

const ArrowImage = styled.img`
    width: 0.625rem;
`;

export default function NumberInput({ value, onChange }) {

    // 1. 화살표 증가 핸들러
    const handleIncrement = () => {
        // 최대/최소값 로직이 필요하다면 여기에 추가
        onChange(value + 1);
    };

    // 2. 화살표 감소 핸들러
    const handleDecrement = () => {
        // 최대/최소값 로직이 필요하다면 여기에 추가
        onChange(value - 1);
    };

    // 3. 타이핑 입력 핸들러
    const handleInputChange = (event) => {
        const rawValue = event.target.value;

        // 숫자(0-9)만 남기고 모두 제거
        const sanitizedValue = rawValue.replace(/[^0-9]/g, '');

        if (sanitizedValue === '') {
            // 빈 문자열이 들어왔을 경우, 0으로 설정하거나 혹은 상위에서 빈 상태를 허용한다면 다른 방식으로 처리할 수 있습니다.
            // 여기서는 사용자 경험을 위해 0으로 설정하도록 합니다.
            onChange(0);
        } else {
            const newValue = parseInt(sanitizedValue, 10);
            if (!isNaN(newValue)) {
                onChange(newValue);
            }
        }
    };

    // 4. 포커스를 잃었을 때 (blur) 핸들러
    const handleInputBlur = (event) => {
        const rawValue = event.target.value;
        const newValue = parseInt(rawValue, 10);

        // 숫자가 아니거나 (NaN) 빈 문자열이면 0으로 확정하여 상태를 정리합니다.
        if (isNaN(newValue) || rawValue === '') {
            onChange(0);
        }
    };


    return (
        <NumberInputContainer>
            {/* 💡 타이핑 입력이 가능한 필드 */}
            <NumberInputField
                type="text"
                value={value}
                onChange={handleInputChange} // 입력값 처리
                onBlur={handleInputBlur} // 포커스 아웃 시 값 정리
            />

            <ArrowContainer>
                <UpArrowContainer onClick={handleIncrement}>
                    <ArrowImage src={IcArrowUp} alt="증가 화살표" />
                </UpArrowContainer>
                <DownArrowContainer onClick={handleDecrement}>
                    <ArrowImage src={IcArrowDown} alt="감소 화살표" />
                </DownArrowContainer>
            </ArrowContainer>
        </NumberInputContainer>
    );
}
